import { FC } from "react";

import __ from "web/Layout/Translations";

import { Nullable } from "web/types/Utils";

interface IExternalLinkProps {
  url: string;
  email?: boolean;
  phone?: boolean;
  className?: string;
  dataT1?: Nullable<string>;
  dataT2?: Nullable<string>;
  label?: Nullable<string>;
  ariaLabel?: string;
}
const ExternalLink: FC<IExternalLinkProps> = ({
  url,
  email = false,
  phone = false,
  className = "",
  dataT1 = null,
  dataT2 = null,
  label = null,
  ariaLabel = undefined,
}) => {
  if (phone) {
    return (
      <a
        className={className}
        href={`tel:${url}`}
        data-t1={dataT1}
        data-t2={dataT2}
      >
        {label || url}
      </a>
    );
  }
  if (email) {
    return (
      <a
        className={className}
        href={`mailto: ${url}`}
        data-t1={dataT1}
        data-t2={dataT2}
      >
        {label || url}
      </a>
    );
  }
  return (
    <a
      className={className}
      href={url.includes("http") ? url : `https://${url}`}
      target="_blank"
      rel="noreferrer"
      data-t1={dataT1}
      data-t2={dataT2}
      aria-label={ariaLabel}
    >
      {label || url}
      <span className="visually-hidden">
        {" "}
        - {__("Link otwiera się w nowej karcie")}
      </span>
    </a>
  );
};

export default ExternalLink;
